exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.barra-lote[data-v-1d125964] {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1030;\n  padding: 12px 16px;\n  background: #343a40;\n  color: #fff;\n  text-align: center;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);\n}\n", ""]);

// exports
